<div (click)="upload()"><ng-content></ng-content></div>

<ion-modal #documentCaptureModal>
    <ng-template>
        <document-capture #documentCaptureComponent [imageTitle]="imageTitle" sxWidth="full" sxHeight="full"></document-capture>
    </ng-template>
</ion-modal>
